import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import { getDemoEntitiesRequest } from "src/services/demo/queries/entities";
import { ConnectedEntity } from "src/types/apps";

import Context from "../../context";

export default function useGetConnectForm() {
	const { state } = useContext(Context);

	const queryClient = useQueryClient();
	const { data } = useQuery<ConnectedEntity[]>({
		queryKey: ["demo", "entities"],
		initialData: []
	});

	useEffect(() => {
		if (state.token && !data.length) {
			getDemoEntitiesRequest(state.token).then((res) => {
				queryClient.setQueryData(["demo", "entities"], res);
			});
		}
	}, [state.token]);

	return {
		entities: data
	};
}
